
import React from 'react';
import { motion } from 'framer-motion';

interface TrustFactorCardProps {
  factor: {
    icon: React.ReactNode;
    title: string;
    description: string;
    color: string;
  };
  index: number;
}

const TrustFactorCard = ({ factor, index }: TrustFactorCardProps) => {
  return (
    <motion.div
      key={index}
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.15, duration: 0.6 }}
      viewport={{ once: true }}
      className="text-center group"
    >
      <motion.div
        whileHover={{ scale: 1.1, rotate: 5 }}
        className={`w-20 h-20 bg-gradient-to-br ${factor.color} rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-2xl transition-all duration-300`}
      >
        {factor.icon}
      </motion.div>
      <h4 className="text-xl font-semibold mb-3">{factor.title}</h4>
      <p className="text-white/90 leading-relaxed">{factor.description}</p>
    </motion.div>
  );
};

export default TrustFactorCard;
